import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import jwt from "jsonwebtoken";
import { Button, Form, Grid, Divider, Icon, Checkbox, TransitionablePortal, Segment, Header } from "semantic-ui-react";
import { connect, useDispatch, useSelector } from "react-redux";
import AxiosCall from "../../config/axios";
import { refreshProfile, updateProfileCleanup, updateProfileRequest } from "../../store/actions/profile";
import { loginRequest } from "../../store/actions/signin";
import google from "../../assets/google.png"

export default function PasswordReset({history}) {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [error, setError]= useState("")
  const [isLoading, setIsLoading] = useState("")
  const [success, setSuccess] = useState("")

  useEffect(() => {
    //  dispatch(refreshProfile(null))
    //  localStorage.removeItem('userData')
    //  localStorage.removeItem('token')
  }, [])
 
  
 const sendCode = async () =>{
  try {
    setIsLoading(true)
    setError('')
   var res = await AxiosCall({
      method: 'post',
      path: 'auth/recoverPassword',
      data: {email}
    })
    setIsLoading(false)
    setSuccess(true)
    setEmail('')
    setTimeout(() => {
      setSuccess('')
    }, 3000);
  } catch (e) {
      if (e?.response) {
        console.log(e?.response)
        const { error } = e?.response?.data;
        setError(error?.message || 'Something went wrong. please try again')
    setIsLoading(false)
  } else {
    console.log(e)
    setError('Something went wrong. please try again')
      }
  }
 }


  
  return (
    <div className="signin">
       <TransitionablePortal
        closeOnTriggerClick
        // onOpen={this.handleOpen}
        // onClose={this.handleClose}
      open={success}
      >
        <Segment
          style={{ right: '0%', position: 'fixed', top: '10%', zIndex: 1000 }}
        >
          <Header>Password reset link sent</Header>
          <p>Please use the link in your email to reset your password</p>
        </Segment>
      </TransitionablePortal>
      <Grid columns="equal">
        <Grid.Column
          tablet="7"
          computer="7"
          className="no-padding "
          only="computer"
        >
          <div className="left-grid flex-justify"></div>
        </Grid.Column>
        <Grid.Column
          tablet="9"
          mobile="16"
          computer="9"
          className="no-padding"
        >
          <div className="right-grid ">
              <div className="x-container">
                <Form onSubmit={sendCode} warning>
                <Link to="/"> <img src={process.env.PUBLIC_URL + "images/logo.png"} /></Link>
                  <h2 className="x-bold">Welcome to B4A.com</h2>
                  <div className="subtitle ">
                  Enter your email to reset password
                  </div>
                  <br/>
                  
                  <Form.Field>
                    <Form.Input
                      fluid
                      id="form-subcomponent-shorthand-input-first-name"
                      placeholder="Email address"
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      type="email"
                      size="massive"
                      value={email}
                    />
                  </Form.Field>
                
                  {error ? (
                    <div className="ui warning message">
                      <small>{error}</small>
                    </div>
                  ) : null}
                
                <div >
               
                  </div>
                  <br />  
                 
                  <Button disabled={!email} loading={isLoading} fluid type="submit" color="green" size="huge">
                    NEXT
                  </Button>
                </Form> 
               
              
              </div>

          </div>
        </Grid.Column>
      </Grid>
    </div>
  );
}
